// @flow

import type { State } from "@store/reducers";
import type {
  DataSecurityGeneralSettings,
  RegistrationEmails,
  PasswordPolicyType,
} from "@modules/service/reducer/system-access/types";
import { transformSecondsInDays } from "@transformers/date";

export const dataSecurityGeneralSettings = (state: State): DataSecurityGeneralSettings => {
  const {
    selfServiceEnabled,
    isLocked,
    enableResetPasswordRequirement,
    inactiveTimeout,
    failedLoginLockout,
    ipRestrictionEnabled,
    passwordResetFrequencyManager,
    passwordResetFrequencyEmployee,
    ipRestrictionWhitelist,
    multiFactorAuthenticationEnabled,
  } = state.service.systemAccess.generalSettings || {};

  return {
    selfServiceEnabled,
    isLocked,
    enableResetPasswordRequirement,
    passwordResetFrequencyManager: transformSecondsInDays(passwordResetFrequencyManager),
    passwordResetFrequencyEmployee: transformSecondsInDays(passwordResetFrequencyEmployee),
    inactiveTimeout,
    failedLoginLockout,
    ipRestrictionEnabled,
    ipRestrictionWhitelist,
    multiFactorAuthenticationEnabled,
  };
};

export const getPasswordPolicy = (state: State): PasswordPolicyType =>
  state.service.systemAccess.passwordPolicy || {
    length: 1,
    lowerCase: 1,
    upperCase: 1,
    gsDigitsOrSpecialChars: 1,
  };

export const getShowSystemAccessPasswordResetModal = (state: State): boolean =>
  state.service.systemAccess.modals.showPasswordResetModal;

export const getShowSystemAccessLogOutLockModal = (state: State): boolean =>
  state.service.systemAccess.modals.showLogOutLockModal;

export const getShowAddIpRestrictionModal = (state: State): boolean =>
  state.service.systemAccess.modals.showAddIpRestrictionModal;

export const getShowClientLogoModal = (state: State): boolean =>
  state.service.systemAccess.modals.showClientLogoModal;

export const getShowBulkRegistrationEmailsModal = (state: State): boolean =>
  state.service.systemAccess.modals.showBulkRegistrationEmailsModal;

export const getShowStandardRegistrationEmailsModal = (state: State): boolean =>
  state.service.systemAccess.modals.showStandardRegistrationEmailsModal;

export const getBulkRegistrationEmailTargets = (state: State): number =>
  state.service.systemAccess.bulkRegistrationEmailTargets;

export const getRegistrationEmails = (state: State): ?RegistrationEmails =>
  state.service.systemAccess.registrationEmails;

export const getClientLogoUrl = (state: State): ?string => state.service.systemAccess.logoUrl;

export const getShowBulkRegistrationEmailsExportModal = (state: State): boolean => {
  return state.service.systemAccess.modals.showBulkRegistrationEmailsExportModal;
};

export const getBulkRegistrationEmails = (state: State): Object => {
  return state.service.systemAccess.emails;
};

export const getEmployeeRegistrationEmailTargets = (state: State): number =>
  state.service.systemAccess.employeeRegistrationEmailTargets;

export const getShowEmployeeRegistrationEmailsModal = (state: State): boolean =>
  state.service.systemAccess.modals.showEmployeeRegistrationEmailsModal;

export const showConfirmEnableMfaModal = (state: State): boolean =>
  state.service.systemAccess.modals.confirmEnableMFA;
